import { ListResponseModel } from ".";
import { CreateRoleRequest, EditRoleRequest, Permission, Role } from "../model/roles/role";
import { apiSlice } from "../stores/base/api-slice";

const rolesEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({

		getRoles: builder.query<ListResponseModel<Array<Role>>, {
			Page: number;
			PageSize: number;
			search?: string;
		}>({
			query: (params) => ({
				url: `/user/role`,
				method: "GET",
				params,
			}),
			providesTags: ["Roles"],
		}),

		getRoleById: builder.query<Role, string>({
			query: (roleId) => ({
				url: `/user/role/${roleId}`,
				method: "GET",
			}),
			providesTags: ["Roles"],
		}),

		getPermissions: builder.query<Permission[], void>({
			query: () => ({
				url: `/user/permission`,
				method: "GET",
			}),
		}),

		createRole: builder.mutation<void, CreateRoleRequest>({
			query: (body) => ({
				url: `/user/role`,
				method: "POST",
				body,
			}),
			invalidatesTags: ["Roles"],
		}),

		editRole: builder.mutation<void, EditRoleRequest>({
			query: (body) => ({
				url: `/user/role`,
				method: "PUT",
				body,
			}),
			invalidatesTags: ["Roles"],
		}),
	}),
});

export const {
	useGetRolesQuery,
	useLazyGetRolesQuery,
	useLazyGetRoleByIdQuery,
	useGetPermissionsQuery,
	useCreateRoleMutation,
	useEditRoleMutation,
} = rolesEndpoints;
